import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { memo } from "react";
import { THistoryDisplayResponse } from "../../models";
import { ICompanyVerificationStatusesConfig } from "../../network";
import { HistoryItem } from "./HistoryItem";
import { Accordion } from "../../../../components/Accordion";

export type Props = {
  history: THistoryDisplayResponse | null;
  statusesConfig: ICompanyVerificationStatusesConfig;
  verificationRequestId: string;
  onLoadMore?: () => void;
};

export const HistoryPanel = memo((props: Props) => {
  const { history, statusesConfig, verificationRequestId, onLoadMore } = props;

  return (
    <Accordion disableGutters>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "800",
            fontSize: "20px",
            lineHeight: "28px",
            letterSpacing: "0.5px",
            color: "#1C1F21",
            textTransform: "capitalize",
          }}
        >
          History
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ marginTop: "8px" }}>
        {history?.history?.length ? (
          <>
            {history.history.map((item, index) => (
              <HistoryItem
                key={`${item.id}-${index}`}
                item={item}
                statusesConfig={statusesConfig}
                verificationRequestId={verificationRequestId}
              />
            ))}
            {history.hasMore && onLoadMore && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "16px",
                }}
              >
                <Typography
                  component="button"
                  onClick={onLoadMore}
                  sx={{
                    color: "#1976d2",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: 500,
                    border: "none",
                    background: "none",
                    textDecoration: "none",
                    padding: "8px 16px",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Load More
                </Typography>
              </Box>
            )}
          </>
        ) : (
          <Typography
            sx={{
              fontSize: "16px",
              color: "#757575",
              fontStyle: "italic",
            }}
          >
            No history available
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
});
